import { fmtDate } from "reporting/pdf/pdfFormatters";
import { getPortfolioPeriodOpeningDate } from "pages/FundPlanner/components/Portfolios/portfolioPeriodDates";

export { getPortfolioPeriodOpeningDate };

export function getPortfolioPeriodPdfLabel(startDate, endDate) {
  const openingDate = getPortfolioPeriodOpeningDate(startDate);
  if (!openingDate || !endDate) return "";
  return `Period ${fmtDate(openingDate)} EOD to ${fmtDate(endDate)} EOD`;
}
